import { render } from "./AcademicAssignmentEdit.vue?vue&type=template&id=4dcd01ac&scoped=true&ts=true"
import script from "./AcademicAssignmentEdit.vue?vue&type=script&lang=ts"
export * from "./AcademicAssignmentEdit.vue?vue&type=script&lang=ts"

import "./AcademicAssignmentEdit.vue?vue&type=style&index=0&id=4dcd01ac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dcd01ac"]])

export default __exports__